import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WalletList } from './wallet.list';
import { FILTER_CONTENT_ITEM, ISelectInput, SearchSelector } from '@portal/shared/ui/filter';
import { FilterStaticBase } from '@portal/shared/ui/filter/src/lib/components/static-base';
import { TransactionFilterList } from '../transaction-filters.list';
import { TransactionFilter } from '../../../enums/transaction-filter.enum';
import { SupportedProcessorSettingsService } from '../../../../../../app/services/supported-processor-settings.service';
import cloneDeep from 'lodash/cloneDeep';
import { Subject } from 'rxjs';

@Component({
  selector: 'portal-filter-wallet-type',
  templateUrl: './wallet-type.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: WalletTypeComponent,
    },
  ],
  standalone: false,
})
export class WalletTypeComponent extends FilterStaticBase {
  @Input() isMainDropdownFilter: boolean;
  @Input() showFilterSubMenu: boolean;
  @Input() isHeightAuto: boolean;
  @Input() updateEntities$!: Subject<any>;
  @Input() updateCounter$!: Subject<any>;
  @Input() subMenuComponentSelected$!: Subject<any>;
  @Input() isOpen = false;
  @Output()
  walletTextName: EventEmitter<string> = new EventEmitter();
  walletText = this.transactionfilters.list.find((filter) => filter.id === TransactionFilter.Wallet)
    .text;
  walletTypes: ISelectInput[];

  constructor(
    private walletList: WalletList,
    private transactionfilters: TransactionFilterList,
    private supportedProcessorSettingsService: SupportedProcessorSettingsService,
  ) {
    super(SearchSelector.Wallet, walletList.getSupportedWallets());
    this.walletTypes = cloneDeep(walletList.list);

    this.supportedProcessorSettingsService.isProcessorFetched$.subscribe(() => {
      this.setAllEntities(walletList.getSupportedWallets());
    });

    this.subMenuComponentSelected$.subscribe((submenu) => {
      if (SearchSelector.Wallet.includes(submenu)) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateEntities$.subscribe(() => {
      if (this.isMainDropdownFilter) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateCounter$.subscribe(() => {
      const localPreSelected: Map<string, ISelectInput> = new Map();
      if (this.criteriaMapPreSelected.has(SearchSelector.Wallet)) {
        const argumentArr = this.getArgumentArray(
          this.criteriaMapPreSelected,
          SearchSelector.Wallet,
        );

        if (this.criteriaMapPreSelected.get(SearchSelector.Wallet)?.argument) {
          argumentArr?.forEach((argument) => {
            localPreSelected.set(argument, {
              id: argument,
              text: this.walletList.getValue(argument),
            });
          });
          this.localPreSelectedEntities = cloneDeep(localPreSelected);
        } else {
          this.localPreSelectedEntities.clear();
        }
      }
      this.updateEntities();
    });
  }

  onFilterAppliedAndEntitiesUpdated(): void {
    this.entities = this.walletList.list;
    this.onFilterApplied();
    this.updateEntities();
    if (this.isOpen) {
      this.closeSubmenus$.next(true);
    }
    this.walletTextName.emit(this.walletText);
    this.isOpen = false;
  }

  private synchronizeLocalPreSelectedEntities(): void {
    if (this.criteriaMapPreSelected?.get(SearchSelector.Wallet)?.argument) {
      const argumentArr = this.getArgumentArray(this.selectedEntities, SearchSelector.Wallet);
      this.localPreSelectedEntities.clear();
      argumentArr.forEach((argument) => {
        this.setLocalPreSelectedEntities(argument, this.walletList.getValue(argument));
      });
    } else {
      this.localPreSelectedEntities.clear();
    }
    this.updateEntities();
  }
}
